import React from "react";
import {NavLink} from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {useAugmentToWithGlobalSearchParams} from "../../routing";
import {useGetInDevnet} from "../../api/hooks/useGetInDevnet";

function NavButton({
  to,
  title,
  label,
}: {
  to: string;
  title: string;
  label: string;
}) {
  const augumentToWithGlobalSearchParams = useAugmentToWithGlobalSearchParams();

  return (
    <NavLink
      to={augumentToWithGlobalSearchParams(to)}
      style={{textDecoration: "none", color: "inherit"}}
    >
      {({isActive}) => (
        <Button
          variant="nav"
          title={title}
          sx={{
            color: (theme) =>
              isActive
                ? theme.palette.tokens.link.normal
                : theme.palette.text.secondary,
            fontSize: "1rem",
            fontWeight: 500,
            px: 1.5,
            py: 1,
            "&:hover": {
              color: (theme) =>
                isActive
                  ? theme.palette.tokens.link.normal
                  : theme.palette.tokens.function.primary,
              backgroundColor: "transparent",
            },
          }}
        >
          {label}
        </Button>
      )}
    </NavLink>
  );
}

export default function Nav() {
  const inDevnet = useGetInDevnet();

  return (
    <Box
      sx={{
        display: {xs: "none", lg: "flex"},
        alignItems: "center",
        gap: 4,
        marginRight: {lg: "1.5rem", xl: "2.25rem"},
      }}
    >
      <NavButton to="/" title="Home" label="Home" />
      <NavButton
        to="/transactions"
        title="View All Transactions"
        label="Transactions"
      />
      <NavButton
        to="/contribution"
        title="View Network Contribution"
        label="Contribution"
      />
      {!inDevnet && (
        <NavButton
          to="/analytics"
          title="View Network Analytics"
          label="Analytics"
        />
      )}
      <NavButton
        to="/validators"
        title="View All Validators"
        label="Validators"
      />
      <NavButton to="/blocks" title="View Latest Blocks" label="Blocks" />
    </Box>
  );
}
